import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';

import { UserMyRadiant as User, EmployeeAttendanceProvider, UtilityMyRadiant } from '@providers/index';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { HelperMyRadiant} from '../../../providers';

import * as mapboxgl from 'mapbox-gl';
import { Geolocation } from '@ionic-native/geolocation';
import { Diagnostic } from "@ionic-native/diagnostic";

import { AndroidPermissions } from '@ionic-native/android-permissions';
import { AppAttendance } from '../attendanceApp/attendance';
import { Api } from '@providers/api/api';

@Component({
  selector   : 'attedance-add',
  templateUrl: 'page.html'
})
export class AddAttendance {
  loading : any;
  formPermit = {
    type   : '',
    date   : '',
    purpose: '',
  };
  state = {
    is_clock_out_with_notes: false,
  };
  parameter = {
    jarak               : '0',
    time                : new Date().getHours() + ":" + new Date().getMinutes(),
    date_attendance     : '',
    date_text           : '',
    alamat              : '',
    full_date           : '',
    notes_lupa_clock_out: '',
    coordinate          : '',
    type                : '',
    clock_type          : 'Clock In',
    location            : null,
    notes               : '',
    id                  : this.userApi.data.Employee_ID,
    code                : this.userApi.data.NIK,
    name                : this.userApi.data.Nama_Karyawan,
  };
  maxRequest = 2;
  data = {
    listType   : [{ Id: 'on-field', Nama: 'On Field' }, { Id: 'standby', Nama: 'Standby' }, { Id: 'office', Nama: 'Office' } ],
    preview_img: './assets/img/no_img.jpg',
    style      : 'mapbox://styles/mapbox/outdoors-v9',
    user       : {
      lat : 0,
      lng : 0,
    },
    kantor : {
      lat: -6.240275,
      lng: 106.819667
    }
  };
  data_attendance: any;
  filePermit     : any;
  map = mapboxgl.Map;
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,    
    public attendanceProvider : EmployeeAttendanceProvider,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,        
    private geolocation       : Geolocation,
    private androidPermissions: AndroidPermissions,
    private diagnostic        : Diagnostic,
    public utility            : UtilityMyRadiant,
    public api                : Api
    ) {
    this.config.set('backButtonText','Add Attendance');
    // this.getListType();
    mapboxgl.accessToken = 'pk.eyJ1IjoiaGFuYWZpcSIsImEiOiJjangwM2N6ZGkwZ2YzNDlwb2VueDFzYjdjIn0.gJa2aKbVqmJ-nAFn8lc1Xg';
  }

  ionViewWillEnter(){
    if (this.utility.buildApk) {
      this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.LOCATION).then(
        result => console.log('Has permission?', result.hasPermission),
        err    => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.LOCATION)
      );
    }
  }
  ionViewDidEnter(){
    let me = this;
    me.loading = me.helper.showLoading("Getting user data...");
    me.getDateServer();
    me.getPosition();
  }  

  getDateServer() {
    let me = this;    
    // this.loading = this.helper.showLoading("Getting user data...");
    let params = {
      id: this.userApi.data.Employee_ID
    };
    // console.log(this.userApi.data);
    this.attendanceProvider.getInfo(params).subscribe((resp: any) => {
      me.maxRequest = me.maxRequest - 1;
      if (me.maxRequest == 0) {
        console.log("maxRequest = ", me.maxRequest);
      }
      if (resp.success) {
        if ("data" in resp){
          me.parameter.date_text       = resp.data.date_text;
          me.parameter.date_attendance = resp.data.attendance_date;
          me.parameter.full_date       = resp.data.full_date;
          me.parameter.time            = resp.data.time;
          me.parameter.clock_type      = resp.data.type;
          me.parameter.type            = resp.data.attendance_type;
          me.data_attendance           = resp.data;
          
          
          //show pop up 
          if (resp.data.date_text != resp.data.attendace_date_text && resp.data.type == "Clock Out") {
            me.state.is_clock_out_with_notes = true;
            me.parameter.full_date = resp.data.attendance_date+' 18:00:00';
            me.helper.presentSwal(" Information","You haven't Clock Out attendance  at "+resp.data.attendace_date_text+" .Please Clock Out first before Clock In.",'warning');
          }
          // this.loading.dismiss();
        }
      }else{
        this.helper.presentToast(resp.msg);
        setTimeout(() => {
          this.viewCtrl.dismiss();
        }, 1000);
      }
    }, (err) => {
      this.helper.presentSwal('error', err);
    }); 
  }

  getPosition(callback?:any){
    let me = this;
    let watch = this.geolocation.watchPosition();
    try {
      this.geolocation.getCurrentPosition().then((data) => {
        // console.log(data.coords);
        this.data.user.lat = data.coords.latitude;
        this.data.user.lng = data.coords.longitude;
        me.parameter.coordinate = data.coords.latitude + "," + data.coords.longitude;
        me.getAlamatByLatLong(data.coords.latitude,data.coords.longitude);
        // callback();
      });
    } catch (err) {
      me.loading.dismiss();
      me.helper.presentToast("Error"+err);
    }
  }

  submit(){
    let me = this;
    if (!this.parameter.type) {
      this.helper.presentSwal('Warning', 'Type required', 'warning');
      return;
    }
    if(!this.parameter.notes){ 
      this.helper.presentSwal('Warning', 'Notes required', 'warning');
      return;
    }

    if (me.state.is_clock_out_with_notes) {
      let element_content = `
      <div style="padding:10px">
        <textarea class="swal-content__textarea" rows="7" id="notes-lupa-clock-out" placeholder="Enter Notes Here.."></textarea>
      </div> 
      `;
      let options = {
        title : "Notes Forgot Clock Out",
        content : element_content
      };
      this.helper.presentSwalCustomContent(options,() => {
        me.parameter.notes_lupa_clock_out = document.getElementById('notes-lupa-clock-out')['value'];
        console.log(me.parameter.notes_lupa_clock_out);
        me.actSubmit();
      })
    }else{
       this.actSubmit();
    }
  }

  actSubmit(){
    this.loading = this.helper.showLoading("Processing Data...");
    if (this.parameter.coordinate != '') {
      this.parameter.location = JSON.stringify(this.data.user);
      this.attendanceProvider.addAttendance(this.parameter).subscribe((resp:any) => {
        if(resp.success){
          this.helper.presentSwal('Success','Your attendance has ben inserted','success');
          this.viewCtrl.dismiss();
          this.nav.setRoot(AppAttendance,{tabIndex:0});
          this.loading.dismiss(); 
        }
      },(err) => {
        this.helper.presentSwal('Error',err);
      });
    }else {
      this.helper.presentSwal('Warning', 'Please check your GPS settings again.', 'warning');
      setTimeout(() => {
        this.viewCtrl.dismiss();
      }, 1000);
      this.loading.dismiss();
    }; 
  }

  cekRadius(){
    let  lat1 = this.data.kantor.lat;
    let lon1 = this.data.kantor.lng;

    let lat2 = this.data.user.lat;;
    let lon2 = this.data.user.lng;;
    let R = 6371; // Radius of the earth in km
    let dLat = (lat2 - lat1) * Math.PI / 180;  // deg2rad below
    let dLon = (lon2 - lon1) * Math.PI / 180;
    let a = 
      0.5 - Math.cos(dLat)/2 + 
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      (1 - Math.cos(dLon))/2;
    let outJarak =  R * 2 * Math.asin(Math.sqrt(a));
    let jarak = '';
    if(outJarak >= 1){
      jarak = outJarak.toFixed(1) + ' km';
    }else{
      jarak = (parseInt(outJarak.toFixed(3)) * 1000) + ' m';
    }
    //cekk jarak 1 = 1km
    this.parameter.jarak = jarak;
  }

  getAlamatByLatLong(lat,long){
    let me = this;
    let params  = {
      key     : '1fde645545b1450cbd1a7a1d25d85a8c',
      q       : lat+','+long,
      pretty  : 1
    }
    this.api.getCustomUrl(this.api.url_opencage+'geocode/v1/json',params).subscribe( (openCage:any) =>{
      // console.log(openCage);
      me.maxRequest = me.maxRequest - 1;
      if (me.maxRequest == 0) {
        console.log("maxRequest = ", me.maxRequest);
      }
      try {
        if (openCage.status.code == '200') {
          me.parameter.alamat = openCage.results[0].formatted;
          // return out;
          console.log("Location => ", me.parameter.alamat);
        }
      } catch (error) {
        me.helper.presentToast("Error location service get !");
        console.log(error);
      } finally{
        me.loading.dismiss();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/attendance/add_attendance/page.ts